import { render, staticRenderFns } from "./ReviewerFeesStat.vue?vue&type=template&id=8a604496&scoped=true"
import script from "./ReviewerFeesStat.vue?vue&type=script&lang=js"
export * from "./ReviewerFeesStat.vue?vue&type=script&lang=js"
import style0 from "./ReviewerFeesStat.vue?vue&type=style&index=0&id=8a604496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a604496",
  null
  
)

export default component.exports